import { Grid, makeStyles } from '@material-ui/core';
import { Button } from '../Button';
import Lock from '@material-ui/icons/Lock';

export const LoginFormButtons = (props: LoginFormButtonsProps) => {
  const { formValues, loading, onForgotPassword } = props;
  const classes = useStyles();

  return (
    <Grid
      container
      className={classes.buttons}
      justifyContent="space-between"
      wrap="wrap-reverse"
    >
      <Grid item xs={12} sm={6}>
        <Button
          disabled={!formValues.username.value}
          variant="text"
          onClick={() => onForgotPassword(formValues.username.value)}
        >
          Forgot Password?
        </Button>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Button
          color="primary"
          fullWidth
          variant="contained"
          startIcon={<Lock />}
          disabled={
            loading ||
            !formValues.username.value.length ||
            !formValues.password.value.length
          }
          type="submit"
        >
          Login
        </Button>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles(() => ({
  buttons: {
    padding: 8,
  },
}));
